import React, { useState } from "react";
import { DELIVERABLES, emptyDeliverables } from "../brandUtils";
import { BmModal, Btn } from "../ui/BrandUI";
import QtyStepper from "../ui/QtyStepper";

// "Set a starting deliverable mix for every shortlisted athlete."
const DealTemplateModal = ({ athleteCount, onApply, onClose }) => {
  const [mix, setMix] = useState(emptyDeliverables());

  return (
    <BmModal
      title="Deal template"
      onClose={onClose}
      footer={
        <>
          <Btn variant="secondary" onClick={onClose}>
            Cancel
          </Btn>
          <Btn className="flex-1" onClick={() => onApply(mix)}>
            Apply to all ({athleteCount})
          </Btn>
        </>
      }
    >
      <p className="bm-body-m text-bm-muted">Set a starting deliverable mix for every shortlisted athlete.</p>
      <div className="mt-2">
        {DELIVERABLES.map(({ key, label }) => (
          <div key={key} className="flex items-center justify-between gap-4 border-b border-bm-border py-[14px] last:border-b-0">
            <span className="bm-body-m text-bm-ink">{label}</span>
            <QtyStepper label={label} value={mix[key]} onChange={(v) => setMix((m) => ({ ...m, [key]: v }))} />
          </div>
        ))}
      </div>
    </BmModal>
  );
};

export default DealTemplateModal;
